<!--
 * @Description: canvas雷达图背景
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-10 11:07:18
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-10 15:50:55
-->
<template>
    <div class = "radar-wrapper">
        <canvas id="myCanvas"></canvas>
    </div>
</template>
<script>
import $ from 'jquery'
export default {
    data() {
        return {
            ww:null,  // canvas的宽度
            wh:null,  // canvas的宽度
            ctx:null,  // 画笔
            fillStyle:"#0864cf",
            enemies:null,
            color_gold:"250,255,255", // 画笔颜色
            time:0, // 次数
            deg_to_pi:null, // 旋转方向  负号代表顺时针
            gobalInterval:null, // 定时器
            center:{   // 中心点
                x: 0,
                y: 0
            }
        }
    },
    created() {
        this.$nextTick(()=>{
            this.intParams();
        })
    },  
    mounted() {
    },
    methods: {
        /**
         * @description: 初始化参数
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        intParams() {
            this.ww = $(".radar-wrapper").outerWidth();
            this.wh = $(".radar-wrapper").outerHeight();
            this.ctx = $("#myCanvas")[0].getContext("2d");
            this.deg_to_pi= - Math.PI/180;  
            this.initRadar();
        },
        /**
         * @description: 重绘
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        getWindowSize() {
            const that = this;
            var c = $("#myCanvas")[0];
            that.ww=$(".radar-wrapper").outerWidth();
            that.wh=$(".radar-wrapper").outerHeight();
            c.width=that.ww;
            c.height=that.wh;
            that.center={x: that.ww/2,y: that.wh/2};
            that.ctx.restore();
            that.ctx.translate(that.center.x,that.center.y);
        },
        /**
         * @description:  渲染canvas
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        initRadar() {
            const that = this;
            $(window).resize(that.getWindowSize);
            that.enemies=Array(10).fill({}).map(
            function(obj){
                return {
                r: Math.random()*200,
                deg: Math.random()*360,
                opacity: 0
                } 
            }
            );
            that.getWindowSize();
        },
        /**
         * @description: 动画启动函数
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        running() {
            const that = this;
            that.gobalInterval = setInterval(that.draw,2);
        },
        /**
         * @description: 停止动画
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        stopRun() {
            const that = this;
            clearInterval(that.gobalInterval)
        },
        /**
         * @description: 渲染主函数
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        draw(){
            const that = this;
            that.time+=1;
            
            that.ctx.fillStyle = that.fillStyle;
            that.ctx.beginPath();
            that.ctx.rect(-2000,-2000,4000,4000);
            that.ctx.fill();
            
            that.ctx.strokeStyle="rgba(255,255,255,0.1)";
            that.ctx.moveTo(-that.ww/2,0);
            that.ctx.lineTo(that.ww/2,0);
            that.ctx.moveTo(0,-that.wh/2);
            that.ctx.lineTo(0,that.wh/2);
            that.ctx.stroke();
            
            that.ctx.strokeStyle=that.Color(1);
            var r=that.wh/2 - 30;  // 雷达扫瞄半径
            var deg=that.time;
            var newpoint=that.Point(r,deg);
            var line_deg = (that.time/2) % 360;
            // console.log(line_deg);
            
            var line_deg_len=100; // 雷达扫瞄宽度
            
            for(var i=0;i<line_deg_len;i++){  // 渲染扫描
                // var deg = (time-i);
                var deg1 = (line_deg-i-1) ;
                var deg2 = (line_deg-i) ;
                
                var point1=that.Point(r,deg1);
                var point2=that.Point(r,deg2);
                var opacity=1-(i/line_deg_len)-0.3;
                if (i==0) opacity=1;
                that.ctx.beginPath();
                // that.ctx.fillStyle="that.white";
                that.ctx.fillStyle=that.Color(opacity);
                that.ctx.moveTo(0,0);
                that.ctx.lineTo(point1.x,point1.y);
                that.ctx.lineTo(point2.x,point2.y);
                // that.ctx.stroke();
                that.ctx.fill();
            }
            
            that.enemies.forEach(function(obj){  // 绘制十字点
                that.ctx.fillStyle=that.Color(obj.opacity);
                var obj_point=that.Point(obj.r,obj.deg);
                
                that.ctx.beginPath();
                that.ctx.arc(
                obj_point.x,obj_point.y,
                4,0,2*Math.PI
                );
                that.ctx.fill();
                
                that.ctx.strokeStyle= that.Color(obj.opacity);
                var x_size=6;
                that.ctx.lineWidth=4;
                that.ctx.beginPath();
                that.ctx.moveTo(obj_point.x-x_size,obj_point.y+x_size);
                that.ctx.lineTo(obj_point.x+x_size,obj_point.y-x_size);
                that.ctx.moveTo(obj_point.x+x_size,obj_point.y+x_size);
                that.ctx.lineTo(obj_point.x-x_size,obj_point.y-x_size);
                that.ctx.stroke();
                
                if (Math.abs(obj.deg - line_deg)<=1){
                obj.opacity=1;
                }
                obj.opacity*=0.99;
                
                that.ctx.strokeStyle= that.Color(obj.opacity);
                that.ctx.lineWidth=1;
                that.ctx.beginPath();
                that.ctx.arc(
                obj_point.x,obj_point.y,
                10*(1/(obj.opacity+0.0001)),0,2*Math.PI
                );
                that.ctx.stroke();
                
                
            });
            
            that.ctx.strokeStyle=that.Color(1);  // 渲染表盘
            var split =90;
            var feature =15; 
            var start_r=45;
            var len = 5;
            
            for(var i=0;i<split;i++){
                that.ctx.beginPath();
                var deg = (i/split) * 360;
                if (i%feature==0){
                    len=8;
                    that.ctx.lineWidth=2;
                }else{
                    len=5; 
                    that.ctx.lineWidth=1;
                }
                
                
                var point1 =that.Point(start_r,deg);
                var point2 =that.Point(start_r+len,deg);
                
                that.ctx.moveTo(point1.x,point1.y);
                that.ctx.lineTo(point2.x,point2.y);
                
                that.ctx.stroke();
                
            }
            
            function CondCircle(r,lineWidth,func_cond){
                
                that.ctx.lineWidth=lineWidth;
                that.ctx.strokeStyle=that.Color(1);
                
                that.ctx.beginPath();
                for(var i=0;i<=360;i++){
                var point =that.Point(r,i);
                if (func_cond(i)){
                    that.ctx.lineTo(point.x,point.y);
                }else{
                    that.ctx.moveTo(point.x,point.y);
                }
                }
                that.ctx.stroke();
            
            }
            // CondCircle(300);
            
            CondCircle(65,2,function(deg){
                return ((deg+that.time/10)%180)<90;
            });
            CondCircle(36,1,function(deg){
                return (deg%3)<1;
            });
            // CondCircle(50,1,function(deg){
            //     return true;
            // });
            
        
        },
        Point(r,deg){
            return {
                x: r*Math.cos(this.deg_to_pi*deg),
                y: r*Math.sin(this.deg_to_pi*deg),
            };
        },
        Color(op){
            return "rgba("+this.color_gold+","+op+")";
        }
    }
        
}
</script>
<style lang="less" scoped>
.radar-wrapper {
    width: 100%; 
    height: 100%;
    canvas {
        background-color: #fff;
        transform: scaleY(-1);
        width: 100%;
        height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/crossAnalysis/canvas-bg.vue